export const CONFIG = {
	originCall: '05',
	companyId: '1018',
	parametrizationType: 'D',
	riskTypeId: 'P',
	declarantChannel: '04',
	startTimeSlot: '10:00',
	endTimeSlot: '20:00',
	actuationId: '67834108',
	originExternalId: '101810',
	preferredTimezone: '2'
};
